import BaseService from './base.service';

const baseService = new BaseService('country');

export default {
  findAll: () => baseService.get('findAll'),
  save: (data = {}) => baseService.post('save', data),
};
